import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { UserProvider } from "./api/userContext";
import Layout from "./components/App";
import AdminRoute from "./components/pages/admin/AdminRoute";
import {ROUTES} from "./config/routes";


/*initialization All css*/
import "./index.css";

// default Warning Error hide
//console.log = console.warn = console.error = () => {};

const LAST_OPENED_PAGE_STORAGE_KEY = "masjidinfos:last_opened_page";
const NON_PERSISTED_PATHS = new Set(["/", "/login", "/profile", "/forgottenpassword"]);

function isPersistablePath(pathname) {
  return Boolean(pathname) && !NON_PERSISTED_PATHS.has(pathname);
}

function LastOpenedPageTracker() {
  const history = useHistory();
  const location = useLocation();
  const hasAttemptedInitialRestoreRef = useRef(false);

  // Restore only once on initial app load so manual navigation is never overridden.
  useEffect(() => {
    if (hasAttemptedInitialRestoreRef.current) {
      return;
    }
    hasAttemptedInitialRestoreRef.current = true;

    if (location.pathname !== "/") {
      return;
    }

    const storedPath = window.localStorage.getItem(LAST_OPENED_PAGE_STORAGE_KEY);
    if (!storedPath || storedPath === "/") {
      return;
    }

    if (storedPath !== location.pathname + location.search + location.hash) {
      history.replace(storedPath);
    }
  }, [history, location.pathname, location.search, location.hash]);

  useEffect(() => {
    if (!isPersistablePath(location.pathname)) {
      return;
    }

    const fullPath = `${location.pathname}${location.search}${location.hash}`;
    window.localStorage.setItem(LAST_OPENED_PAGE_STORAGE_KEY, fullPath);
  }, [location.pathname, location.search, location.hash]);

  return null;
}

/*
=>version : 0.1
=>Event : Rendering al content to web
=>Action: define all routes and page
@return HTML
*/

class Root extends React.Component {
  render() {
    return (
      <>
        <UserProvider>
          <BrowserRouter basename="/">
            <LastOpenedPageTracker />
            <Layout>
              <Switch>
              
                <Route exact path={ROUTES.HOME.path} component={ROUTES.HOME.component} />
                <Route path={ROUTES.LOGIN.path} component={ROUTES.LOGIN.component} />
                <Route path={ROUTES.PROFILE.path} component={ROUTES.PROFILE.component} />
                <Route path={ROUTES.FORGOTTEN_PASSWORD.path} component={ROUTES.FORGOTTEN_PASSWORD.component} />
                
                <AdminRoute path={ROUTES.DASHBOARD.path} component={ROUTES.DASHBOARD.component} />
                <AdminRoute path={ROUTES.CREATE_ARTICLE.path} component={ROUTES.CREATE_ARTICLE.component} />
                <AdminRoute path={ROUTES.ALL_ARTICLES.path} component={ROUTES.ALL_ARTICLES.component} />
                <AdminRoute path={ROUTES.CREATE_EVENT.path} component={ROUTES.CREATE_EVENT.component} />
                <AdminRoute path={ROUTES.ALL_EVENTS.path} component={ROUTES.ALL_EVENTS.component} />
                <AdminRoute path={ROUTES.IMPORT_EVENTS.path} component={ROUTES.IMPORT_EVENTS.component} />
                <AdminRoute path={ROUTES.ALL_NOTIFICATIONS.path} component={ROUTES.ALL_NOTIFICATIONS.component} />
                <AdminRoute path={ROUTES.CREATE_NOTIFICATION.path} component={ROUTES.CREATE_NOTIFICATION.component} />
                <AdminRoute path={ROUTES.ALL_MESSAGES.path} component={ROUTES.ALL_MESSAGES.component} />

              
                <Route
                  path={ROUTES.ABOUT.path}
                  component={ROUTES.ABOUT.component}
                />
                <Route
                  path={ROUTES.ARTICLES.path}
                  component={ROUTES.ARTICLES.component} />
                <Route
                  path={ROUTES.ARTICLE_DETAILS.path}
                  component={ROUTES.ARTICLE_DETAILS.component}
                />

                <Route
                  path={ROUTES.NEWS.path}
                  component={ROUTES.NEWS.component}
                />
                <Route
                  path={ROUTES.QUIZ.path}
                  component={ROUTES.QUIZ.component}
                />
                <Route
                  path={ROUTES.DHIKR.path}
                  component={ROUTES.DHIKR.component}
                />
                <Route
                  path={ROUTES.QURAN.path}
                  component={ROUTES.QURAN.component}
                />
                <Route
                  path={ROUTES.PRIVACY_POLICY.path}
                  component={ROUTES.PRIVACY_POLICY.component}
                />

                <Route
                  path={ROUTES.EVENTS.path}
                  component={ROUTES.EVENTS.component}
                />
              
                <Route
                  path={ROUTES.EVENT_DETAILS.path}
                  component={ROUTES.EVENT_DETAILS.component}
                />

                <Route component={ROUTES.ERROR.component} />
              
              </Switch>
            </Layout>
          </BrowserRouter>
        </UserProvider>
      </>
    );
  }
}

ReactDOM.render(
  <React.StrictMode>
      <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
